export enum MediaTypeEnum {
  default = '',
  image = 'image',
  gif = 'gif',
  video = 'video',
  youtube = 'youtube'
}
